import { connectListView, ListView } from "../../../UI/view/list-view";
import { liquidBillingCreditDS } from "./liquid-billing-datasource";
import { CreateTransfer, CreateTransferDataSource } from "./liquid-create-transfer";
import { liquidBillingListColumns, liquidBillingListToolbar, liquidListFilters } from "./liquid-invoice-list";

export const liquidBillingCreditList = {
  name: 'liquidBillingCreditList',
  filters: liquidListFilters,
  columns: liquidBillingListColumns.filter(x => x.accessor !== 'dateShipped'),
  additionalModals: [
    {
      form: CreateTransfer,
      repository: CreateTransferDataSource,
      name: 'createTransfer',
      title: 'Create Transfer',
    }
  ],
  toolbar: liquidBillingListToolbar('liquidBillingCreditList'),
} as ListView;


export const [LiquidBillingCreditList, LiquidBillingInvoiceCreditDataSource] = connectListView(liquidBillingCreditList, liquidBillingCreditDS);